"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "erto-e-casso": {
    "9acfb433": [{
      "hkey": "3a826db9",
      "slug": "erto-e-casso",
      "name": "Erto e Casso",
      "primary": true,
      "skipSearch": false
    }],
    "cavalle": [{
      "hkey": "3a826db9",
      "slug": "erto-e-casso",
      "name": "Erto e Casso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ef7c2339": [{
      "hkey": "3a826db9",
      "slug": "erto-e-casso",
      "name": "Erto e Casso",
      "primary": true,
      "skipSearch": false
    }],
    "col-della-ruava": [{
      "hkey": "3a826db9",
      "slug": "erto-e-casso",
      "name": "Erto e Casso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b162ae7a": [{
      "hkey": "3a826db9",
      "slug": "erto-e-casso",
      "name": "Erto e Casso",
      "primary": true,
      "skipSearch": false
    }],
    "forcai": [{
      "hkey": "3a826db9",
      "slug": "erto-e-casso",
      "name": "Erto e Casso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "04d15380": [{
      "hkey": "3a826db9",
      "slug": "erto-e-casso",
      "name": "Erto e Casso",
      "primary": true,
      "skipSearch": false
    }],
    "liron": [{
      "hkey": "3a826db9",
      "slug": "erto-e-casso",
      "name": "Erto e Casso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f6fb6111": [{
      "hkey": "3a826db9",
      "slug": "erto-e-casso",
      "name": "Erto e Casso",
      "primary": true,
      "skipSearch": false
    }],
    "pineda": [{
      "hkey": "3a826db9",
      "slug": "erto-e-casso",
      "name": "Erto e Casso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3e2a4bd0": [{
      "hkey": "3a826db9",
      "slug": "erto-e-casso",
      "name": "Erto e Casso",
      "primary": true,
      "skipSearch": false
    }],
    "val-del-pont": [{
      "hkey": "3a826db9",
      "slug": "erto-e-casso",
      "name": "Erto e Casso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;